import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useRef, useState, useCallback, useEffect } from 'react';
import '../../utils/assertion.esm.js';
import '../../utils/ssr.esm.js';
import '../../utils/number.esm.js';
import '../../utils/array.esm.js';
import '../../utils/breakpoint.esm.js';
import '../../utils/context.esm.js';
import '../../utils/dom.esm.js';
import '../../utils/tabbable.esm.js';
import '../../utils/dom-query.esm.js';
import '../../utils/logger.esm.js';
import '../../utils/focus.esm.js';
import '../../utils/function.esm.js';
import '../../utils/keydown.esm.js';
import '../../utils/lazy.esm.js';
import '../../utils/object.esm.js';
import { mergeRefs } from '../../utils/react-helpers.esm.js';
import '../../utils/style-props.esm.js';
import '../../utils/tailwind.esm.js';
import Box from '../Box/index.esm.js';
import IconButton from '../IconButton/index.esm.js';
import Flex from '../Flex/index.esm.js';
import '../../hooks/use-safe-layout-effects.esm.js';
import '../../hooks/use-callback-ref.esm.js';
import '../../hooks/use-clickable.esm.js';
import '../../hooks/use-clipboard.esm.js';
import '../../hooks/use-combobox-dropdown-style.esm.js';
import { useComboboxStyle } from '../../hooks/use-combobox-style.esm.js';
import '../../hooks/use-controllable.esm.js';
import '../../hooks/use-local-storage.esm.js';
import '../../hooks/use-media.esm.js';
import '../../hooks/use-prefers-dark-mode.esm.js';
import '../../hooks/use-dark-mode.esm.js';
import '../../hooks/use-force-update.esm.js';
import '../../hooks/use-descendant.esm.js';
import { useId } from '../../hooks/use-id.esm.js';
import '../../hooks/use-previous.esm.js';
import '../../hooks/use-disclosure.esm.js';
import '../../hooks/use-dropdown-style.esm.js';
import '../../hooks/use-latest-ref.esm.js';
import '../../hooks/use-event-listener.esm.js';
import '../../hooks/use-event-listener-v2.esm.js';
import '../../hooks/use-update-effect.esm.js';
import '../../hooks/use-focus-on-hide.esm.js';
import '../../hooks/use-pointer-event.esm.js';
import '../../hooks/use-focus-on-pointerdown.esm.js';
import '../../hooks/use-focus-on-show.esm.js';
import '../../hooks/use-fork-ref.esm.js';
import '../../hooks/use-hints.esm.js';
import '../../hooks/use-input-style.esm.js';
import '../../hooks/use-key-press.esm.js';
import '../../hooks/use-lock-body-scroll.esm.js';
import '../../hooks/use-platform.esm.js';
import '../../hooks/use-shortcut.esm.js';
import '../Popper/popper.modifiers.esm.js';
import { usePopper } from '../Popper/use-popper.esm.js';
import '../Popper/use-popper-v2.esm.js';
import { useMultipleSelection, useCombobox } from 'downshift';
import ComboboxContextProvider from './context.esm.js';
import { compareItems } from './utils.esm.js';
import Dropdown from './components/Dropdown.esm.js';

var Combobox = function Combobox(props) {
  var _selectedItems$;

  var ref = props.ref,
      _props$selectedItems = props.selectedItems,
      rawSelectedItems = _props$selectedItems === void 0 ? [] : _props$selectedItems,
      rawItems = props.items,
      onChange = props.onChange,
      _props$mode = props.mode,
      mode = _props$mode === void 0 ? 'multiple' : _props$mode,
      providedId = props.id,
      _props$placeholder = props.placeholder,
      placeholder = _props$placeholder === void 0 ? 'Select...' : _props$placeholder,
      _props$size = props.size,
      size = _props$size === void 0 ? 'md' : _props$size,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'bottom' : _props$placement,
      _props$clearValueOnBl = props.clearValueOnBlur,
      clearValueOnBlur = _props$clearValueOnBl === void 0 ? true : _props$clearValueOnBl,
      _props$allowClear = props.allowClear,
      allowClear = _props$allowClear === void 0 ? true : _props$allowClear,
      _props$loading = props.loading,
      loading = _props$loading === void 0 ? false : _props$loading,
      _props$closeOnSelect = props.closeOnSelect,
      closeOnSelect = _props$closeOnSelect === void 0 ? mode === 'single' : _props$closeOnSelect,
      _props$readOnly = props.readOnly,
      readOnly = _props$readOnly === void 0 ? false : _props$readOnly,
      _props$validateSelect = props.validateSelectedItems,
      validateSelectedItems = _props$validateSelect === void 0 ? true : _props$validateSelect,
      _props$hideItemOnSele = props.hideItemOnSelect,
      hideItemOnSelect = _props$hideItemOnSele === void 0 ? mode === 'tag' : _props$hideItemOnSele,
      rest = _objectWithoutPropertiesLoose(props, ["ref", "selectedItems", "items", "onChange", "mode", "id", "placeholder", "size", "placement", "clearValueOnBlur", "allowClear", "loading", "closeOnSelect", "readOnly", "validateSelectedItems", "hideItemOnSelect"]);

  var id = "combobox-" + useId(providedId);
  var containerRef = useRef(null);
  var inputRef = useRef(null);

  var _useState = useState(''),
      inputValue = _useState[0],
      setInputValue = _useState[1];

  var _useState2 = useState(false),
      focus = _useState2[0],
      setFocus = _useState2[1];

  var _useState3 = useState(0),
      width = _useState3[0],
      setWidth = _useState3[1];

  var setWidthTimeout = useRef();
  var items = rawItems.map(function (item) {
    return typeof item === 'string' ? {
      value: item
    } : item;
  });
  var selectedItemsProp = rawSelectedItems.map(function (item) {
    return typeof item === 'string' ? {
      value: item
    } : item;
  });
  var validSelectedItemsProp = validateSelectedItems ? selectedItemsProp.filter(function (selectedItem) {
    return items.map(function (_ref) {
      var value = _ref.value;
      return value;
    }).includes(selectedItem.value);
  }) : selectedItemsProp;

  var _useMultipleSelection = useMultipleSelection({
    initialSelectedItems: validSelectedItemsProp
  }),
      addSelectedItem = _useMultipleSelection.addSelectedItem,
      getDropdownProps = _useMultipleSelection.getDropdownProps,
      setSelectedItems = _useMultipleSelection.setSelectedItems,
      removeSelectedItem = _useMultipleSelection.removeSelectedItem,
      selectedItems = _useMultipleSelection.selectedItems;

  var filteredItems = items.filter(function (item) {
    return item.value.toLowerCase().includes(inputValue.toLowerCase().trim()) && (!hideItemOnSelect || !selectedItems.some(function (selectedItem) {
      return compareItems(item, selectedItem);
    }));
  });

  var _useCombobox = useCombobox({
    inputValue: inputValue,
    items: filteredItems,
    stateReducer: function stateReducer(state, actionAndChanges) {
      var _changes$inputValue;

      var changes = actionAndChanges.changes,
          type = actionAndChanges.type;

      switch (type) {
        case useCombobox.stateChangeTypes.InputKeyDownEnter:
        case useCombobox.stateChangeTypes.ItemClick:
          {
            var selectedItem = changes.selectedItem;

            if (selectedItem) {
              setInputValue('');

              if (mode === 'multiple' || mode === 'tag') {
                var selectedIndex = selectedItems.findIndex(function (item) {
                  return compareItems(item, selectedItem);
                });
                setSelectedItems(selectedIndex === -1 ? [].concat(selectedItems, [selectedItem]) : selectedItems.filter(function (_, index) {
                  return index !== selectedIndex;
                }));
              } else {
                setSelectedItems([selectedItem]);
              }
            }

            if (closeOnSelect) {
              closeMenu();
            }
          }
          return _extends({}, changes, {
            highlightedIndex: state.highlightedIndex,
            isOpen: true
          });

        case useCombobox.stateChangeTypes.InputChange:
          setInputValue((_changes$inputValue = changes.inputValue) != null ? _changes$inputValue : '');
          break;
      }

      return changes;
    }
  }),
      openMenuInner = _useCombobox.openMenu,
      closeMenu = _useCombobox.closeMenu,
      isOpen = _useCombobox.isOpen,
      highlightedIndex = _useCombobox.highlightedIndex,
      getMenuProps = _useCombobox.getMenuProps,
      getInputProps = _useCombobox.getInputProps,
      getComboboxProps = _useCombobox.getComboboxProps,
      getItemProps = _useCombobox.getItemProps;

  var openMenu = useCallback(function () {
    if (readOnly) return;
    openMenuInner();
  }, [readOnly]);

  var _usePopper = usePopper({
    forceUpdate: isOpen,
    gutter: 8,
    placement: placement
  }),
      popper = _usePopper.popper,
      update = _usePopper.update,
      reference = _usePopper.reference;

  useEffect(function () {
    setSelectedItems(validSelectedItemsProp);
  }, [JSON.stringify(validSelectedItemsProp)]);
  useEffect(function () {
    if (typeof rawItems[0] === 'string' || typeof rawSelectedItems[0] === 'string') {
      onChange == null ? void 0 : onChange(selectedItems.map(function (item) {
        return item.value;
      }));
    } else {
      onChange == null ? void 0 : onChange(selectedItems);
    }
  }, [selectedItems]);
  useEffect(function () {
    if (!isOpen && clearValueOnBlur) {
      setInputValue('');
    }
  }, [clearValueOnBlur, isOpen]);
  useEffect(function () {
    update();
  }, [inputValue, selectedItems, update, rawItems]);
  useEffect(function () {
    // update due to changing size of input
    if (mode === 'tag') {
      update();
    }
  }, [mode, selectedItems, update]);
  useEffect(function () {
    var ro;

    if (containerRef.current) {
      ro = new ResizeObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.target === containerRef.current) {
            // Debounce to avoid spamming state update
            window.clearTimeout(setWidthTimeout.current);
            setWidthTimeout.current = window.setTimeout(function () {
              setWidth(entry.contentRect.width);
              update();
            }, 250);
          }
        });
      });
      ro.observe(containerRef.current);
    }

    return function () {
      var _ro;

      (_ro = ro) == null ? void 0 : _ro.disconnect();
    };
  }, [containerRef, update]);
  var context = {
    mode: mode,
    open: isOpen,
    getMenuProps: getMenuProps,
    getItemProps: getItemProps,
    addSelectedItem: addSelectedItem,
    removeSelectedItem: removeSelectedItem,
    items: filteredItems,
    selectedItems: selectedItems,
    highlightedIndex: highlightedIndex,
    size: size,
    popper: popper,
    width: width,
    inputValue: inputValue,
    hideItemOnSelect: hideItemOnSelect
  };
  var displayValue = inputValue || ((_selectedItems$ = selectedItems[0]) == null ? void 0 : _selectedItems$.value) || '';

  var getPlaceholder = function getPlaceholder() {
    if (typeof placeholder === 'function') {
      if (typeof rawItems[0] === 'string') {
        return placeholder(selectedItems.map(function (item) {
          return item.value;
        }));
      }

      return placeholder(selectedItems);
    }

    if (mode === 'single') {
      return displayValue || placeholder;
    }

    if (mode === 'multiple') {
      return selectedItems.length > 1 ? selectedItems.length + " items selected" : displayValue || placeholder;
    }

    return !displayValue ? placeholder : '';
  };

  var _useComboboxStyle = useComboboxStyle({
    size: size,
    focus: focus
  }),
      wrapperStyle = _useComboboxStyle.wrapperStyle,
      inputStyle = _useComboboxStyle.inputStyle,
      tagStyle = _useComboboxStyle.tagStyle,
      tagIconStyle = _useComboboxStyle.tagIconStyle,
      inputIconStyle = _useComboboxStyle.inputIconStyle;

  return React__default.createElement(ComboboxContextProvider, {
    value: context
  }, React__default.createElement(Box, {
    ref: mergeRefs(reference.ref, containerRef),
    onKeyDown: function onKeyDown(e) {
      if (e.key === 'Escape') {
        e.stopPropagation();
      }
    }
  }, React__default.createElement(Flex, _extends({}, getComboboxProps(), {
    dangerouslySetClassName: "form-input"
  }, wrapperStyle, {
    onMouseDown: function onMouseDown(e) {
      var _inputRef$current;

      if (e.defaultPrevented) return;
      e.preventDefault();
      (_inputRef$current = inputRef.current) == null ? void 0 : _inputRef$current.focus();
      openMenu();
    }
  }), React__default.createElement(Flex, {
    flex: "flex-1",
    flexWrap: "flex-wrap",
    alignItems: "items-center",
    gap: "gap-x-1.5"
  }, mode === 'tag' && selectedItems.map(function (item) {
    return React__default.createElement(Flex, _extends({
      key: (item.group || '') + item.value
    }, tagStyle), item.value, React__default.createElement(IconButton, _extends({}, tagIconStyle, {
      onMouseDown: function onMouseDown(e) {
        e.preventDefault();
        setSelectedItems(selectedItems.filter(function (selectedItem) {
          return !compareItems(item, selectedItem);
        }));
      }
    })));
  }), React__default.createElement(Box, _extends({
    as: "input",
    id: id,
    ref: mergeRefs(ref, inputRef),
    dangerouslySetClassName: "form-input",
    size: inputValue.length < 20 ? Math.max(inputValue.length, 1) : undefined,
    placeholder: getPlaceholder(),
    placeholderColor: !displayValue ? 'placeholder-gray-300' : 'placeholder-gray-600'
  }, inputStyle, getInputProps(_extends({}, getDropdownProps({
    ref: inputRef
  }), {
    readOnly: readOnly,
    onFocus: function onFocus() {
      setFocus(true);

      if (!isOpen) {
        openMenu();
      }
    },
    onBlur: function onBlur() {
      setFocus(false);
    }
  })), rest))), loading && React__default.createElement(IconButton, _extends({}, inputIconStyle, {
    icon: "spinner",
    label: "loading"
  })), !loading && allowClear && !!displayValue && !readOnly && React__default.createElement(IconButton, _extends({}, inputIconStyle, {
    icon: "close",
    label: "close",
    size: size,
    onClick: function onClick() {
      setSelectedItems([]);
    }
  }))), React__default.createElement(Dropdown, null)));
};

export default Combobox;
//# sourceMappingURL=index.esm.js.map
